import React, { Component } from 'react';
import SettingsManager from './SettingsManager';
import {
  getUserSettings,
  modifyUserSettings,
  resetUserSettings,
  getUserSettingsConfig
} from './SettingsManager.actions';
import Constants from '../../../../common/constants/Constants';
import Store from '../../../../redux/Store';
import { showSnackbar } from '../../../../common/state/snackbar/Snackbar.actions';

class SettingsManagerContainer extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      modifiedRows: [],
      config: []
    };
  }

  componentDidMount() {
    getUserSettingsConfig()
      .then(res => {
        let configsObject = JSON.parse(res.body);
        this.setState({ config: configsObject.UserSettings });
        return getUserSettings();
      })
      .then(res => this.setState({ data: res.body }));
  }

  render() {
    return (
      <SettingsManager
        dataContent={this.state.data}
        modifiedRowsContent={this.state.modifiedRows}
        onModifyCallback={this._onModify}
        onSaveCallback={this._onSave}
        onResetCallBack={this._onReset}
        config={this.state.config}
      />
    );
  }

  _onModify = (propertyName, value, obj, index) => {
    let newObj = {
      ...obj,
      [propertyName]: value
    };
    let newData = this.state.data.slice(0);
    let newModifiedRows = this.state.modifiedRows.slice(0);

    newData[index] = newObj;
    this.setState({
      data: newData,
      modifiedRows: this.addValueToArrayIfNotExist(newModifiedRows, index)
    });
  };

  _onSave = index => {
    let newData = this.state.data.slice(0);
    let newModifiedRows = this.state.modifiedRows.slice(0);
    modifyUserSettings(newData[index]).then(res => {
      if (res.body) {
        newData[index] = res.body;
        this.setState({
          data: newData,
          modifiedRows: this.deleteValueFromArrayIfExist(newModifiedRows, index)
        });
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
            message: 'Successfully updated setting.'
          })
        );
      } else {
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
            message: 'Failed updating setting.'
          })
        );
      }
    });
  };

  _onReset = index => {
    let newData = this.state.data.slice(0);
    resetUserSettings(newData[index].UserSettingId).then(res => {
      if (res.body) {
        newData[index] = res.body;
        this.setState({
          data: newData
        });
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.SUCCESS,
            message: 'Successfully reseted to default setting.'
          })
        );
      } else {
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
            message: 'Failed reseting setting.'
          })
        );
      }
    });
  };

  addValueToArrayIfNotExist(array, value) {
    if (array.indexOf(value) === -1) {
      array.push(value);
    }
    return array;
  }

  deleteValueFromArrayIfExist(array, value) {
    if (array.indexOf(value) !== -1) {
      array.splice([array.indexOf(value)], 1);
    }
    return array;
  }
}

export default SettingsManagerContainer;
